import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Quote} from 'lucide-react'

const testimonials = [
  {
    name: "Ana Carolina",
    role: "Analista de Marketing",
    text: "Estudo inglês por estar cada vez mais presente no meu trabalho. Com a English Work, consegui evoluir no meu ritmo, sem pressão. O suporte da Lucy IA é incrível, sempre disponível quando preciso praticar.",
    color: "#0E8EA0",
  },
  {
    name: "Osvaldo Junior",
    role: "Desenvolvedor de Software",
    text: "Para mim, o inglês vai ajudar muito na minha realização profissional e pessoal. A metodologia da English Work me surpreendeu — é prática, direta e funciona. Recomendo para quem tem rotina corrida.",
    color: "#B038B2",
  },
  {
    name: "Sandra Monique",
    role: "Estudante Universitária",
    text: "Eu quero aprender inglês para viajar e ter mais oportunidades. A English Work me deu confiança para começar. O app é fácil de usar e as aulas ao vivo são muito dinâmicas.",
    color: "#F5C542",
  },
]

export default function TestimonialsSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section id="depoimentos" className="py-20 md:py-28 bg-white">
      <div ref={ref} className="max-w-7xl mx-auto px-5">
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Feedbacks dos nossos <span style={{ color: "#0E8EA0" }}>alunos</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Veja depoimentos de quem já conhece a metodologia English Work
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`bg-gray-50 rounded-2xl p-8 border-t-4 hover:shadow-lg transition-all duration-500 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{
                borderTopColor: t.color,
                transitionDelay: isVisible ? `${(i + 1) * 150}ms` : "0ms",
              }}
            >
              <Quote size={28} style={{ color: t.color }} className="mb-4 opacity-40" />
              <p className="text-gray-600 text-base leading-relaxed mb-6 italic">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3">
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-sm"
                  style={{ backgroundColor: t.color }}
                >
                  {t.name.split(" ").map(n => n[0]).join("")}
                </div>
                <div>
                  <p className="text-gray-900 font-bold text-sm">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
